module.exports = {"TXTWCL_Add_to_bet_slip":{"id":"TXTWCL_Add_to_bet_slip","defaultMessage":"Ajouter au bulletin de pari"}}